export enum SupportedLocale {
	SV = "SV",
	EN = "EN",
	NB = "NB",
}
